<template>
     <div 
          v-if="!isLoading && displayContent.length > 0"
          id="auto-carousel"
          ref="slideGroup"
          :show-arrows="false" 
          class="auto-slide-carousel d-flex">
              <div class="carousel-content" :style="{ transform: `translateX(${translateX}px)` }">
                <div v-for="(document, i) in displayContent" :key="document.id || i" class="ma-2">
                <v-card 
                  class="document-card-carousel d-flex flex-column my-3 shadow-sm" 
                  flat 
                  width="320px" 
                  style="height: 220px; border-radius: 16px !important; border: 1px solid #ececec; overflow: hidden;"
                  @click="viewDocument(document)">

                  <div v-if="document.preview_image" class="document-preview-carousel" style="height: 120px; overflow: hidden;">
                    <v-img 
                      :src="document.preview_image" 
                      aspect-ratio="1.77" 
                      height="100%"
                      style="object-fit: cover; background-color: white;" />
                  </div>
                  <div v-else class="document-preview-carousel d-flex align-center justify-center" style="height: 120px; background-color: #f0f2f5;">
                     <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#b0bec5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                     </svg>
                  </div>

                  <div class="d-flex flex-column pa-3" style="flex-grow: 1; overflow: hidden;">
                    <h3 class="font-weight-bold mb-1 font-rubik"
                      style="font-size: 0.95rem !important; line-height: 1.3; color: #0E121B; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;">
                      {{ document.name }}
                    </h3>
                    <p v-if="document.description" class="font-rubik text--secondary mb-0"
                      style="font-size: 0.75rem !important; line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis; max-height: 1.7em;">
                      {{ document.description }}
                    </p>

                    <div class="d-flex align-center mt-auto pt-1">
                      <div v-if="document.num_pages && document.num_pages > 0" class="d-flex align-center rounded-lg px-1 py-0 mr-2"
                        style="background: #F7F7F7;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                          stroke="rgb(105 105 105)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="mr-1 lucide lucide-file-text">
                          <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/>
                          <polyline points="14 2 14 8 20 8"/>
                          <line x1="16" y1="13" x2="8" y2="13"/>
                          <line x1="16" y1="17" x2="8" y2="17"/>
                          <line x1="10" y1="9" x2="8" y2="9"/>
                        </svg>
                        <span class="font-rubik" style="color: rgb(105 105 105) !important; font-size: 0.7rem;">{{ document.num_pages }} pág.</span>
                      </div>
                      
                      <div class="d-flex align-center rounded-lg px-1 py-0 mr-2" style="background: #F7F7F7;">
                        <svg style="width: 12px; height: 12px; min-width: 12px; min-height: 12px;"
                          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                          stroke="rgb(105 105 105)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="mr-1 lucide lucide-circle-user-round-icon lucide-circle-user-round">
                          <path d="M18 20a6 6 0 0 0-12 0" />
                          <circle cx="12" cy="10" r="4" />
                          <circle cx="12" cy="12" r="10" />
                        </svg>
                        <span class="font-rubik"
                          style="color: rgb(105 105 105) !important; font-size: 0.7rem; max-width: 70px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                          {{ document.author || 'Anónimo' }}
                        </span>
                      </div>
                      <v-spacer></v-spacer>
                      <div class="d-flex align-center rounded-lg px-1 py-0" style="background: #F7F7F7;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                          stroke="rgb(105 105 105)" stroke-width="2" style="height: 12px; width: 12px;"
                          stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-timer-icon lucide-timer">
                          <line x1="10" x2="14" y1="2" y2="2" />
                          <line x1="12" x2="15" y1="14" y2="11" />
                          <circle cx="12" cy="14" r="8" />
                        </svg>
                        <span class="font-rubik ml-1" style="color: rgb(105 105 105) !important; font-size: 0.7rem;">
                          {{ formatDate(document.created_at) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </v-card>
              </div>
              </div>
            </div>
        
</template>

<script>
export default {
  name: 'LastExampleCarousel',
  data() {
    return {
      translateX: 0,
      animationSpeed: 3,
      animationId: null,
      carouselDocuments: [],
      isLoading: true,
      error: null,
    };
  },
  computed: {
    displayContent() {
      if (this.carouselDocuments.length === 0) return [];
      // Duplicar el contenido para crear efecto de ciclo continuo
      // Asegurarse de que haya suficientes elementos para duplicar y que no sea excesivo
      const baseContent = this.carouselDocuments;
      let content = [...baseContent];
      while (content.length > 0 && content.length < 15) { // Evitar duplicación excesiva si hay pocos docs
          content = [...content, ...baseContent];
          if (baseContent.length === 0) break; // Evitar bucle infinito si baseContent está vacío
      }
      return content;
    }
  },
  async mounted() {
    await this.fetchCarouselDocuments();
    if (this.carouselDocuments.length > 0) {
        this.startAnimation();
    }
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    this.stopAnimation();
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    async fetchCarouselDocuments() {
      this.isLoading = true;
      this.error = null;
      try {
        const response = await this.axios.get('/community/carousel-examples');
        if (response.data.success) {
          this.carouselDocuments = response.data.documents;
        } else {
          this.error = response.data.error || 'No se pudieron cargar los ejemplos.';
          this.carouselDocuments = []; // Limpiar en caso de error
        }
      } catch (err) {
        console.error('Error fetching carousel documents:', err);
        this.error = 'Error al conectar con el servidor.';
        this.carouselDocuments = []; // Limpiar en caso de error
      } finally {
        this.isLoading = false;
      }
    },
    startAnimation() {
        this.$nextTick(() => {
            if (!this.$el || !this.$el.querySelector('.carousel-content') || this.carouselDocuments.length === 0) {
                return;
            }

            const animate = () => {
                this.translateX -= this.animationSpeed;
                
                // Cuando se ha desplazado todo el primer conjunto original, reiniciar
                const singleSetWidth = this.$el.querySelector('.carousel-content').offsetWidth / (this.displayContent.length / this.carouselDocuments.length);

                if (Math.abs(this.translateX) >= singleSetWidth) {
                    this.translateX = 0;
                }
                
                this.animationId = requestAnimationFrame(animate);
            };
            
            this.animationId = requestAnimationFrame(animate);
        });
    },
    stopAnimation() {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
    },
    handleResize() {
      this.stopAnimation();
      this.translateX = 0;
       if (this.carouselDocuments.length > 0) {
        this.startAnimation();
      }
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      // date.setHours(date.getHours() - 2); // Ajuste horario específico, considerar si es necesario globalmente

      if (isNaN(date.getTime())) return '';

      const now = new Date();
      const diff = now - date;

      const seconds = Math.floor(diff / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);
      const weeks = Math.floor(days / 7);
      const months = Math.floor(days / 30.44); // Promedio de días en un mes
      const years = Math.floor(days / 365.25); // Promedio de días en un año

      if (seconds < 60) {
        return `hace ${seconds} s`;
      } else if (minutes < 60) {
        return `hace ${minutes} min`;
      } else if (hours < 24) {
        return `hace ${hours} h`;
      } else if (days < 7) {
        return `hace ${days} d`;
      } else if (weeks < 4.345) { // Aproximadamente 4.345 semanas en un mes
        return `hace ${weeks} sem`;
      } else if (months < 12) {
        return `hace ${months} m`;
      } else {
        return `hace ${years} a`;
      }
    },
    viewDocument(document) {
      // Navegar a la vista del documento si es necesario
      // Por ahora, solo un log o ninguna acción, ya que el carrusel es de ejemplos.
      // Si se requiere navegación: this.$router.push(`/app/document/${document.id}`);
      // console.log("Ver documento (ejemplo carrusel):", document.id);
      this.$router.push({ path: '/app/document/' + document.id });
    }
  }
}
</script>   


<style scoped>

.auto-slide-carousel {
  position: relative;
  overflow: hidden;
  padding-bottom: 10px; /* Espacio para que las sombras no se corten */
}

/* Efecto de desenfoque en los laterales */
.auto-slide-carousel::before,
.auto-slide-carousel::after {
  content: '';
  position: absolute;
  top: 0;
  width: 150px; /* Reducido para que se vea más contenido */
  height: 100%;
  z-index: 2;
  pointer-events: none;
}

.auto-slide-carousel::before {
  left: 0;
  background: linear-gradient(to right, rgb(249, 250, 251, 1) 20%, rgb(249, 250, 251, 0));
}

.auto-slide-carousel::after {
  right: 0;
  background: linear-gradient(to left, rgb(249, 250, 251, 1) 20%, rgb(249, 250, 251, 0));
}


.carousel-content {
  display: flex;
  transition: transform 0.1s linear; /* Mantener lineal para suavidad */
  will-change: transform;
}

.document-card-carousel {
  transition: box-shadow 0.2s ease-in-out, transform 0.2s ease-in-out;
  cursor: pointer;
}

.document-card-carousel:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0,0,0,0.1);
}


/* Animación para dispositivos móviles */
@media (max-width: 600px) {
  .auto-slide-carousel .carousel-content {
    /* overflow-x: visible !important; No es necesario con el bucle */
  }
   .auto-slide-carousel::before,
   .auto-slide-carousel::after {
    width: 50px; /* Más pequeño en móviles */
  }
}


/* Estilos para el carrusel automático */
.carousel-container {
  max-width: 100% !important;
  overflow: hidden;
  position: relative;
}

.auto-slide-carousel >>> .v-slide-group__prev,
.auto-slide-carousel >>> .v-slide-group__next {
  display: none !important;
}

.font-rubik { /* Asegurar que la fuente Rubik esté disponible o usar una alternativa */
  font-family: 'Rubik', sans-serif;
}

</style>